import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from 'src/app/modules/case-new-view/alert.service';
import { ProceedCaseComponent } from '../../proceed-case/proceed-case.component';
import { UserService } from 'src/app/core/services/user.service';
import { AlertRecordComponent } from 'src/app/modules/case-new-view/components/alert-record/alert-record.component';
import { AlertRecordService } from 'src/app/modules/case-new-view/alert-record.service';
enum status {
  initial = 'Abierto',
  proceed = 'Asignado',
  refused = 'Rechazado',
}
enum desition {
  initial = 'Abierto',
  proceed = 'Procede',
  refused = 'No procede',
}

@Component({
  selector: 'see-alert',
  templateUrl: './see-alert.component.html',
  styleUrls: ['./see-alert.component.scss'],
})
export class SeeAlertComponent implements OnInit {
  status = status;
  desition = desition;
  constructor(
    private readonly route: ActivatedRoute,
    private readonly alertService: AlertService,
    private readonly dialog: MatDialog,
    private readonly userService: UserService,
    private readonly cd: ChangeDetectorRef,
    private readonly alertRecordService: AlertRecordService
  ) {}

  ngOnInit() {
    this.getAlertInformation();
  }
  public back() {
    window.history.go(-1);
  }
  public showMore: boolean = false;
  alertRecord: AlertRecordComponent;
  alert;
  getAlertInformation() {
    const id = this.route.snapshot.paramMap.get('id');
    this.alertService.getAlert(id).subscribe((alert) => {
      this.alert = alert;
    });
  }
  get cantipifi() {
    return (
      this.userService.permissions.editCases &&
      this.alert?.assigned == undefined &&
      this.alert?.reason == undefined
    );
  }
  proceedCase() {
    this.dialog
      .open(ProceedCaseComponent, {
        width: '700px',
        maxHeight: '80vh',
        data: {
          alert: this.alert,
        },
        panelClass: 'class-ras-create',
      })
      .afterClosed()
      .subscribe({
        next: (alert: any) => {
          if (alert.updated) {
            this.alert = alert.alert;
            this.alertRecordService.updatedRecord.next(true);
          }
          // if (caseUpdated) {
          //   let index = this.allCases.findIndex(
          //     (item) => item._id == caseUpdated._id
          //   );
          //   this.allCases.splice(index, 1, caseUpdated);
          //   this.setData(this.allCases);
          //   this.table.renderRows();
          // }
        },
      });
  }
  openRecord() {
    this.showMore = true;
    this.cd.detectChanges();
  }
}
